module.exports = __webpack_public_path__ + "static/media/sand_king.fe3094bd.png";